/**
 * 买家端注册 / 验证码 / 资料完善 API（对接真实后端 /api/buyer/auth/**）
 * - send-code:  POST /buyer/auth/send-code  —— 发送邮箱验证码（REGISTER / RESET）
 * - register:   POST /buyer/auth/register   —— 邮箱 + 验证码 + 密码 注册，成功直接返回登录态
 * - profile:    PUT  /buyer/auth/profile     —— 注册后自助完善企业信息（仅非空字段更新）
 */
import { post, put } from '@/api/request';

export type SendCodeType = 'REGISTER' | 'RESET';

export interface SendCodeRequest {
  email: string;
  type: SendCodeType;
  /** 邮件语言，跟随买家端语言偏好（zh 默认 / en） */
  lang?: 'zh' | 'en';
}

export interface BuyerRegisterRequest {
  email: string;
  code: string;
  password: string;
  companyName?: string;
  contactName?: string;
  country?: string;
}

/** 完善企业信息请求体（四个资料字段均可选，后端仅更新非空字段） */
export interface BuyerProfileRequest {
  buyerId: string;
  companyName?: string;
  contactName?: string;
  country?: string;
  phone?: string;
}

/**
 * 修改登录密码请求体（买家自助，登录态）。
 * 身份由后端从 JWT 解析，请求体只带密码；oldPassword 仅账号已设过密码时必填。
 */
export interface ChangePasswordRequest {
  oldPassword?: string;
  newPassword: string;
}

/** 后端 BuyerLoginVO（与 BuyerAuthContext 对齐；仅取前端需要字段） */
export interface BuyerLoginVO {
  token: string;
  tokenType: string;
  expiresIn: number;
  buyerId: string;
  buyerCode: string;
  companyName: string;
  email: string;
  orgId: string;
}

export const authApi = {
  sendCode: (req: SendCodeRequest) => post<void>('/buyer/auth/send-code', req),
  register: (req: BuyerRegisterRequest) => post<BuyerLoginVO>('/buyer/auth/register', req),
  updateProfile: (req: BuyerProfileRequest) => put<void>('/buyer/auth/profile', req),
  changePassword: (req: ChangePasswordRequest) => put<void>('/buyer/auth/password', req),
};

export default authApi;
